<app-modal #aiOptionsModal [modalConfig]="modalConfig">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div
          *ngIf="isLoading"
          class="w-100 d-flex flex-column justify-content-center align-items-center"
          style="background-color: #fff; height: 700px">
          <div class="d-flex align-items-center flex-column">
            <div class="loading-stars">
              <img
                src="/assets/star-lg-pink.svg"
                class="star-lg"
                alt="Ai Stars" />
              <img
                src="/assets/star-sm-pink.svg"
                class="star-sm"
                alt="Ai Stars" />
            </div>
            <span class="fw-700 fs-18"
              >Generating Options<span class="ellipsis-anim ms-1"
                ><span>.</span><span>.</span><span>.</span></span
              ></span
            >
          </div>
        </div>
        <div *ngIf="error">
          <app-error-message [message]="error" />
        </div>
        <div *ngIf="generatedOptions">
          <h2>{{ generatedOptions.competency }}</h2>
          <p>
            <strong
              >{{ generatedOptions.strand }}, Level
              {{ generatedOptions.level }}</strong
            >
          </p>
          <app-safehtml [html]="generatedOptions.gi"></app-safehtml>
          <p class="fs-14 fw-300 pt-2">
            Choose some of these suggestion options and add them to your log.
          </p>
          <div>
            <div
              *ngFor="let option of visibleOptions"
              class="card border border-secondary border-3 h-100 my-3">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col col-title">
                    <span class="fs-16 fw-800">{{ option.title }}</span>
                  </div>
                  <div class="col col-toggle">
                    <i
                      class="btn-switch bi-toggle-off fs-3"
                      role="button"
                      (click)="toggleOption(option)"
                      [ngClass]="{
                        'bi bi-toggle-off': !option.selected,
                        'bi bi-toggle-on': option.selected
                      }"></i>
                  </div>
                </div>
                <div class="pt-3">
                  <p>{{ option.description }}</p>
                </div>
                <ng-container *ngIf="option.glai_content_id">
                  <div class="d-flex option-feedback">
                    <button
                      class="smart-response-feedback-btn"
                      [class.active]="option.user_feedback === 'thumbs_up'"
                      (click)="submitFeedback(option, 'thumbs_up')"
                      ngbTooltip="Good Response">
                      <i
                        class="bi"
                        [class.bi-hand-thumbs-up-fill]="
                          option.user_feedback === 'thumbs_up'
                        "
                        [class.bi-hand-thumbs-up]="
                          option.user_feedback !== 'thumbs_up'
                        "></i>
                    </button>
                    <button
                      class="smart-response-feedback-btn"
                      [class.active]="option.user_feedback === 'thumbs_down'"
                      (click)="submitFeedback(option, 'thumbs_down')"
                      ngbTooltip="Bad Response">
                      <i
                        class="bi"
                        [class.bi-hand-thumbs-down-fill]="
                          option.user_feedback === 'thumbs_down'
                        "
                        [class.bi-hand-thumbs-down]="
                          option.user_feedback !== 'thumbs_down'
                        "></i>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button (click)="closeModal()" class="btn btn-reset">Cancel</button>
    <div>
      <button
        class="btn btn-ai mx-1"
        (click)="showMore()"
        *ngIf="
          generatedOptions &&
          visibleOptions &&
          generatedOptions.options.length > visibleOptions.length
        ">
        Generate More
      </button>
      <button
        class="btn btn-primary"
        (click)="addSelectedOptions()"
        [disabled]="hasSelections == false">
        Add Selected
      </button>
    </div>
  </div>
</app-modal>
